document.addEventListener("DOMContentLoaded", () => {

  const country = Shopify.country;

  const currentAddonConfig =
    window.productAddonMetafields?.find(
      (addon) => addon.market_code === country
    );

  const isCryoCountry = currentAddonConfig?.cryo_enabled === true;

  document.querySelectorAll(".fertility-plan").forEach((section) => {

    const cards = [...section.querySelectorAll("[data-plan-card]")];
    const radios = [...section.querySelectorAll(".fertility-card__radio")];

    const button = section.querySelector("[data-fertility-button]");
    const addonButton = section.querySelector("[data-addon-button]");
    const buttonPrice = section.querySelector("[data-button-price]");

    if (!button) return;

    function getSelectedRadio() {
      return radios.find((r) => r.checked);
    }

    function updateCryoTrigger() {

      const selected = getSelectedRadio();

      if (!selected || !button) return;
      const isSubscription =
        selected.dataset.planType === "subscription";

      if (isCryoCountry && !isSubscription) {
        button.setAttribute("data-open-cryo-popup", "");
        addonButton?.setAttribute("data-open-cryo-popup", "");
        console.log("Cryo ENABLED");
      } else {
        button.removeAttribute("data-open-cryo-popup");
        addonButton?.removeAttribute("data-open-cryo-popup", "");
        console.log("Cryo DISABLED");
      }
    }

    function updateActiveCard() {
      cards.forEach((card) =>
        card.classList.remove("fertility-card--active")
      );

      const selected = getSelectedRadio();

      if (!selected) return;

      selected
        .closest(".fertility-card")
        ?.classList.add("fertility-card--active");
    }

    function updateButtonPrice() {
      const selected = getSelectedRadio();

      if (!selected) return;

      let price = Number(selected.dataset.price);
      const currency = Shopify.currency.active;

      if (selected.dataset.planType === "subscription") {
        const discount = window?.SapyenFertility?.discount;
        price = (price - discount);
      }

      // buttonPrice.innerHTML = new Intl.NumberFormat(
      //   Shopify.locale || "en",
      //   {
      //     style: "currency",
      //     currency: Shopify.currency.active,
      //   }
      // ).format(price / 100);

      const formattedButtonPrice = new Intl.NumberFormat(
        Shopify.locale || "en",
        {
          style: "currency",
          currency: Shopify.currency.active,
        }
      ).format(price / 100);

        const finalButtonPrice =
    currency === "AUD" || currency === "CAD"
      ? formattedButtonPrice.replace(/^(A\$|CA\$)/, "$")
      : formattedButtonPrice;

      buttonPrice.innerHTML = finalButtonPrice;


      const addonPrice = addonButton.querySelector(".fertility-addon_price");
      console.log(addonPrice,"addonPrice");

      if (!addonPrice) {
        return;
      }
      let currentAddonPrice = Number(addonButton.dataset.price);
      if (!Number.isFinite(currentAddonPrice)) {
        return;
      }
      if (selected.dataset.planType != "subscription") {
        const discount = window?.SapyenFertility?.discount;
        currentAddonPrice = (currentAddonPrice);
      }

      // addonPrice.innerText = new Intl.NumberFormat(
      //   Shopify.locale || "en",
      //   {
      //     style: "currency",
      //     currency: Shopify.currency.active,
      //   }
      // ).format(currentAddonPrice / 100);
          if (addonPrice) {
  const formattedPrice = new Intl.NumberFormat(
    Shopify.locale || "en",
    {
      style: "currency",
      currency: Shopify.currency.active,
    }
  ).format(currentAddonPrice / 100);

  

  const finalAddonPrice =
    currency === "AUD" || currency === "CAD"
      ? formattedPrice.replace(/^(A\$|CA\$)/, "$")
      : formattedPrice;

  addonPrice.textContent = finalAddonPrice;
}


    }

    function getSubscriptionProperties(selected) {

      if (selected.dataset.planType !== "subscription") {
        return {
          quantity: null,
          interval: null,
          discount: 0,
        };
      }

      const config = window.subscriptionPlanMetafields;

      return {
        quantity: config?.no_of_kits,
        interval: config?.dispatch_interval,
        discount: Math.round((config?.plan_discount ?? 0) * 100),
      };
    }

    function syncStore() {
      const selected = getSelectedRadio();

      if (!selected) return;

      const subscription = getSubscriptionProperties(selected);

      window.SapyenCart.add("main", {
        id: Number(selected.value),
        quantity: 1,
        properties: {
          _purchase_type: selected.dataset.planType,
          _subscription: selected.dataset.planType === "subscription",
          _quantity: subscription?.quantity,
          _interval: subscription?.interval,
          _discount: subscription?.discount,
          _cryo: false,
        },
      });

      window.SapyenCart.log();
    }


    radios.forEach((radio) => {
      radio.addEventListener("change", () => {
        updateActiveCard();
        syncStore();
        updateCryoTrigger();
        updateButtonPrice();

        const selected = getSelectedRadio();

    if (selected?.dataset.planType === "subscription") {
      SapyenAnalytics.track("Subscription Plan Selected", {
        plan_id: selected.value,
        plan_type: selected.dataset.planType,
        price: Number(selected.dataset.price) / 100,
        currency: Shopify.currency.active,
        country: Shopify.country,
      });
    }
   
      });

    });


    if (addonButton) {
      addonButton.addEventListener("click", async (event) => {
        event.preventDefault();

        const selected = getSelectedRadio();

        if (!selected) {
          console.warn("No plan selected");
          return;
        }

        const isSubscription =
          selected.dataset.planType === "subscription";

        const addonHandle = isSubscription
          ? currentAddonConfig?.bundle_addon_handle
          : currentAddonConfig?.single_addon_handle;

        const addonProduct = await fetch(`/products/${addonHandle}.js`)
          .then((res) => res.json());

        const addonVariant = addonProduct?.variants?.[0]?.id;
        const addonProductName = addonProduct?.title;
        const addonPrice = addonProduct?.variants?.[0]?.price;

      // Track the selected addon with its product name
        SapyenAnalytics.track("Addon Selected on Main Product", {
          plan_id: selected.value,
          plan_type: selected.dataset.planType,
          price: Number(selected.dataset.price) / 100,

          addon_product_name: addonProductName,
          addon_product_handle: addonProduct.handle,
          addon_variant_id: String(addonVariant),
          addon_price: Number(addonPrice) / 100,

          currency: Shopify.currency.active,
          country: Shopify.country,
        });


        const previousMain = window.SapyenCart.get("main");

        if (!previousMain) {
          console.warn("No main cart item found");
          return;
        }

        window.SapyenCart.remove("main");

        const subscription = getSubscriptionProperties(selected);

        window.SapyenCart.add("main", {
          id: addonVariant,
          quantity: 1,

          properties: {
            _purchase_type: "addon",
            _upgraded_from_variant: previousMain.id,
            _upgraded_from_purchase_type:
              previousMain.properties?.purchase_type,
            _subscription: isSubscription,
            _quantity: isSubscription
              ? subscription.quantity
              : null,
            _interval: isSubscription
              ? subscription.interval
              : null,
            _discount: isSubscription
              ? subscription.discount
              : 0,
            _cryo: false,
          },
        });

        window.SapyenCart.log();

        if (isSubscription) {

          await window.SapyenCartApi.addSapyenCartToShopify();
          await window.SapyenCartApi.openCartDrawer();

          return;
        }

        if (isCryoCountry) {
          window.dispatchEvent(
            new CustomEvent("sapyen:open-cryo")
          );

          return;
        }

        await window.SapyenCartApi.addSapyenCartToShopify();
        await window.SapyenCartApi.openCartDrawer();
      });
    }

    button.addEventListener("click", async (event) => {
      event.preventDefault();

      const selected = getSelectedRadio();

      if (!selected) {
        console.warn("No plan selected");
        return;
      }

      const isSubscription =
        selected.dataset.planType === "subscription";

      syncStore();

      const main = window.SapyenCart.get("main");

      if (!main) {
        console.error("Main cart item not found");
        return;
      }

      if (isSubscription) {
        window.SapyenCart.update("main", {
          ...main,
          properties: {
            ...main.properties,
            _subscription: true,
            _cryo: false,
          },
        });

        await window.SapyenCartApi.addSapyenCartToShopify();
        await window.SapyenCartApi.openCartDrawer();

        return;
      }

      if (isCryoCountry) {

        window.dispatchEvent(
          new CustomEvent("sapyen:open-cryo")
        );
        return;
      }

      window.SapyenCart.update("main", {
        ...main,
        properties: {
          ...main.properties,
          _subscription: false,
          _cryo: false,
        },
      });

      await window.SapyenCartApi.addSapyenCartToShopify();
      await window.SapyenCartApi.openCartDrawer();
    });


    updateActiveCard();
    syncStore();
    updateCryoTrigger();
    updateButtonPrice();
  });
});